import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import * as clientActions from "../../redux/actions/clientActions";
import Dashboard from "../../layouts/Dashboard";
import AppointmentsProvider from "./AppointmentsProvider/AppointmentsProvider";
import AppointmentsStart from "./AppointmentsStart";
import AppointmentSettings from "./AppointmentSettings";
import AppointmentCredits from "./AppointmentCredits";
import Availability from "../Availability";

const mapDispatchToProps = {
  ...clientActions,
};

const mapStateToProps = (state) => {
  const {
    client: { features },
  } = state;

  return { features };
};

const AppointmentsIndex = ({ getFeatures, features }) => {
  React.useEffect(() => {
    getFeatures();
  }, [getFeatures]);

  const { path } = useRouteMatch("/appointments");

  const hasAppointmentsAccess = features && features.appointments;

  React.useEffect(() => {
    if (!hasAppointmentsAccess) {
      window.location.href = "/scheduler/index";
    }
  });

  if (!hasAppointmentsAccess) return null;

  return (
    <AppointmentsProvider>
      <Switch>
        <Route exact path={`${path}`}>
          <Dashboard scrollableContent disableContentPadding>
            <AppointmentsStart />
          </Dashboard>
        </Route>
        <Route exact path={`${path}/settings`}>
          <Dashboard>
            <AppointmentSettings />
          </Dashboard>
        </Route>
        <Route exact path={`${path}/member/:id`}>
          <Dashboard>
            <AppointmentCredits />
          </Dashboard>
        </Route>
        <Route exact path={`${path}/working-hours/:userUuid`}>
          <Availability />
        </Route>
      </Switch>
    </AppointmentsProvider>
  );
};

AppointmentsIndex.propTypes = {
  getFeatures: PropTypes.func.isRequired,
  features: PropTypes.shape({
    appointments: PropTypes.bool.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentsIndex);
